/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload-cloud': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g _fill="currentColor"><path pid="0" d="M24 10.413a5.817 5.817 0 00-1.772-4.167 5.711 5.711 0 00-3.447-1.585.249.249 0 01-.191-.12 7.684 7.684 0 00-14.1 2.294.251.251 0 01-.227.2A4.59 4.59 0 000 11.609a4.324 4.324 0 001.236 3.21A5.519 5.519 0 004.841 16.2a1 1 0 00-.03-2 3.288 3.288 0 01-2.172-.8A2.374 2.374 0 012 11.609 2.576 2.576 0 012.954 9.6a2.6 2.6 0 012.167-.527 1 1 0 001.2-.919 5.686 5.686 0 0110.82-2.088.962.962 0 00.941.57 3.7 3.7 0 012.758 1.051A3.752 3.752 0 0122 10.413a3.835 3.835 0 01-3.438 3.787 1 1 0 00.132 1.992.961.961 0 00.131-.009A5.807 5.807 0 0024 10.413z"/><path pid="1" d="M12.707 8.989a1 1 0 00-1.414 0l-3.5 3.5A1 1 0 008.5 14.2h1.75a.249.249 0 01.25.25v7.25a1.5 1.5 0 003 0v-7.25a.249.249 0 01.25-.25h1.75a1 1 0 00.707-1.707z"/></g>'
  }
})
